import { DeviceTypeValue } from '@constants/deviceTypes'
import helpers from '@lib/analytics/amplitude/helpers'

const { sendEvent } = helpers

const cookieBannerVisible = (deviceType: DeviceTypeValue, retailerPartnerNumber: string, locale: string): void => {
  sendEvent('cookie-banner-visible', {
    deviceType,
    locale: locale,
    partner: retailerPartnerNumber,
  })
}

const cookieBannerAccepted = (): void => {
  sendEvent('cookie-banner-accepted', {
    consentType: 'all',
  })
}

const cookieBannerRejected = (): void => {
  sendEvent('cookie-banner-rejected', {
    consentType: 'all',
  })
}

export default {
  cookieBannerVisible,
  cookieBannerAccepted,
  cookieBannerRejected,
}
